﻿export const initialise = () => {
    const overlay = document.querySelector<HTMLDialogElement>('.component-search-overlay')
    if (!overlay) return

    const dialogInputSearch = document.querySelector<HTMLInputElement>('.component-search-overlay .attrax-search-widget .attrax-form-item__input')
    const dialogWidgetSearch = document.querySelector<HTMLDivElement>('.component-search-overlay .component-search-overlay__widget-search')
    const buttonClose = document.querySelector<HTMLButtonElement>('.component-search-overlay .component-search-overlay__button-close')
    const buttonOpen = document.querySelector<HTMLButtonElement>('.component-header .component-header__action-search-overlay')
    const heading = document.querySelector<HTMLHeadingElement>('.component-search-overlay .component-search-overlay__heading')
    if (!dialogInputSearch || !dialogWidgetSearch || !buttonClose || !buttonOpen || !heading) return

    bindEvents(overlay, buttonClose, buttonOpen)
    addLanguagePackEntries(buttonClose, buttonOpen, heading)
    autocompleteSuggestions(dialogWidgetSearch)
}

export const openOverlay = (overlay: HTMLDialogElement) => {
    if (overlay.open) return
    overlay.showModal()
    document.body.classList.add('overlay--open')
}
export const closeOverlay = (overlay: HTMLDialogElement) => {
    if (!overlay.open) return
    overlay.close()
    document.body.classList.remove('overlay--open')
}

const bindEvents = (overlay: HTMLDialogElement, buttonClose: HTMLButtonElement, buttonOpen: HTMLButtonElement) => {
    buttonOpen.addEventListener('click', () => {
        openOverlay(overlay)
    })

    buttonClose.addEventListener('click', () => {
        closeOverlay(overlay)
    })

    overlay.addEventListener('close', () => {
        document.body.classList.remove('overlay--open')
    })
}

const addLanguagePackEntries = (buttonClose: HTMLButtonElement, buttonOpen: HTMLButtonElement, heading: HTMLHeadElement) => {
    buttonClose.setAttribute('aria-label', '{{js.dialog.search-overlay.button-close.aria-label}}')
    buttonOpen.setAttribute('aria-label', '{{js.dialog.search-overlay.button-open.aria-label}}')
    heading.textContent = '{{js.dialog.search-overlay.heading.content}}'
}

const autocompleteSuggestions = (dialogWidgetSearch: HTMLDivElement) => {
    const autocompleteSuggestion = document.querySelector<HTMLElement>('.component-search-overlay__widget-search.autocomplete-suggestions')
    if (!autocompleteSuggestion) return

    autocompleteSuggestion.setAttribute('popover', '')
    dialogWidgetSearch?.appendChild(autocompleteSuggestion)
}